// Library Imports
import { BrowserRouter } from "react-router-dom";
import { Agentation } from "agentation";

//  Local Imports
import Router from "./routes";
import { Toast } from "./components/shared";
import SecurityOtpModal from "./components/SecurityOtpModal";
import { SocketProvider } from "./redux/socket/socket.jsx";

const App = () => {
  return (
    <SocketProvider>
      <BrowserRouter>
        <Router />
        <Toast />
        <SecurityOtpModal />
        {import.meta.env.DEV && <Agentation />}
      </BrowserRouter>
    </SocketProvider>
  );
};

export default App;
